import type { ReactNode } from 'react';

interface OptionCardProps {
  title: ReactNode;
  desc?: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  /** 卡片右側內容（價格 / 圖示等）。 */
  trailing?: ReactNode;
  testId?: string;
}

/**
 * 大尺寸觸控選項卡 — 對應 kiosk-screens 設計系統 `Component/OptionCard`。
 * 用於首頁三大入口、收票方式、發票選項等單選清單。
 */
export function OptionCard({
  title,
  desc,
  selected = false,
  disabled = false,
  onClick,
  trailing,
  testId,
}: OptionCardProps): JSX.Element {
  return (
    <button
      type="button"
      className={`k-option${selected ? ' k-option--selected' : ''}`}
      disabled={disabled}
      onClick={onClick}
      aria-pressed={selected}
      data-testid={testId}
    >
      <div className="k-row">
        <div style={{ flex: 1 }}>
          <div className="k-option__title">
            {selected ? '✓ ' : ''}
            {title}
          </div>
          {desc !== undefined && <div className="k-option__desc">{desc}</div>}
        </div>
        {trailing !== undefined && <div>{trailing}</div>}
      </div>
    </button>
  );
}
